import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export const initProductCardGalleries = () => {
    const galleries = document.querySelectorAll('[data-product-card-gallery]');
    if (!galleries.length) return;

    galleries.forEach(el => {
        if (el.dataset.galleryInit) return;
        el.dataset.galleryInit = '1';

        const slides = el.querySelectorAll('.swiper-slide');
        const paginationEl = el.querySelector('[data-product-card-pagination]');
        const hasMultiple = slides.length > 1;

        new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 1,
            allowTouchMove: hasMultiple,
            watchOverflow: true,
            init: hasMultiple,
            initialSlide: 0,
            loop: false,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });

        if (!hasMultiple && paginationEl) {
            paginationEl.style.display = 'none';
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardGalleries);
} else {
    initProductCardGalleries();
}
